package com.advaita.cloud.drive.ui.components

/**
 * A single user input a small generic dialog collects before submitting (e.g. the
 * archive-compress dialog's name + format — see [ModalRequest.Params] /
 * [com.advaita.cloud.drive.ui.store.FileBrowserStore.collectParams]). [type] drives
 * the control the dialog renders.
 *
 * Frontend-only, never on the wire — deliberately NOT in `:shared` and NOT
 * `@Serializable`. (This is also why it is named `FormField` rather than reusing
 * `OfferParam`/`OfferParamType`: those exact names were deliberately deleted in
 * 0df7e61 when the "offer" model was replaced by the curated-workflow/OPC flow, and
 * resurrecting dead vocabulary here would invite confusion with that unrelated,
 * removed concept. This is general small-dialog-form infra, not an offer.)
 */
data class FormField(
    val key: String,
    val label: String,
    val type: FormFieldType,
    val options: List<FormFieldOption> = emptyList(),
    val required: Boolean = true,
    /** Prefilled value for a TEXT field (e.g. the suggested archive name). Ignored
     *  for SELECT, which defaults to its first option. */
    val defaultValue: String = "",
)

data class FormFieldOption(val value: String, val label: String)

enum class FormFieldType { SELECT, TEXT }
